<template>
    <AuthLayout>
        <div
            class="flex w-full flex-col items-center bg-white px-6 pb-6 sm:max-w-[344px]"
        >
            <div class="h-[160px] w-[160px]">
                <img
                    :src="yourLink"
                    class="h-full w-full object-contain"
                    alt="Expect verification link"
                />
            </div>

            <div
                class="mt-6 text-center text-3xl font-bold leading-9 text-[#161E2E]"
            >
                {{ $t("vue.thank_you_for_signing_up") }}
            </div>

            <div
                class="mt-6 max-w-[406px] text-center text-[12.25px] font-normal leading-[1.42] text-black"
            >
                {{ $t("vue.verify_email_message") }}
            </div>

            <div
                class="mt-6 max-w-[406px] text-center text-[12.25px] font-normal leading-[1.42] text-black"
            >
                {{ $t("vue.didnt_receive_verification_email") }}
            </div>

            <div
                v-if="verificationLinkSent"
                class="mt-6 text-center text-[12.25px] font-medium leading-[1.42] text-green-600"
            >
                {{ $t("vue.new_verification_link_sent") }}
            </div>

            <form class="w-full" @submit.prevent="submit">
                <AtomicButton
                    class="mt-6 w-full !rounded-md !bg-[#088BEA] !py-3 !text-sm !font-medium !text-white !shadow-none hover:!bg-[#067DD2] focus:!ring-0"
                    :disabled="form.processing"
                    type="submit"
                >
                    {{ $t("vue.resend_verification_email") }}
                </AtomicButton>

                <div class="flex justify-center">
                    <inertia-link
                        :href="route('logout')"
                        method="post"
                        as="button"
                        class="mt-6 pb-2 text-xs font-medium text-[#088BEA] hover:text-[#067DD2]"
                    >
                        {{ $t("vue.logout") }}
                    </inertia-link>
                </div>
            </form>
        </div>
    </AuthLayout>
</template>

<script setup lang="ts">
import route from "ziggy-js";
import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    status: {
        type: String,
        default: "",
    },
});

const form = useForm({});

const submit = async () => {
    form.post(route("verification.send"));
};

const verificationLinkSent = computed(() => {
    return props.status === "verification-link-sent";
});

const yourLink = new URL(
    "/resources/js/assets/images/your-link.svg",
    import.meta.url,
).href;
</script>
